import React, { Component } from "react";
import { Tabs, WhiteSpace } from "antd-mobile-v2";
import "./index.less";
import sectioValue from "../../api/service/secsstion";
import tool from "../../api/tool";
import { lawData, policy, answer, focusing, processData } from "./cont";
import { get, headerGet, post, postRaw } from "../../api/service/services";
import allUrl from "../../api/allUrl";
const tabs = [
  { title: "法律法规" },
  { title: "网上信访" },
  { title: "问题解答" },
  { title: "聚焦信访" },
];
export default class Guide extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }
  componentDidMount() {}
  //获取各地网上信访数据
  getLetterListData = () => {};
  tabRender = (data) => {
    return data.map((item, index) => {
      return (
        <div
          key={index}
          className="duide-text"
          style={{
            paddingRight: item.time ? "1rem" : "0",
          }}
        >
          <p
            className="duide-ps"
            onClick={() => {
              if(!item.type) return;
              this.props.history.push({
                pathname: '/journ',
                state: {
                  mationType: item.type,
                },
              });
            }}
          >
            •&nbsp;&nbsp;{item.name}
          </p>
          <p
            style={{
              position: "absolute",
              top: "50%",
              marginTop: "-10px",
              right: "0.08rem",
            }}
          >
            {item.time}
          </p>
        </div>
      );
    });
  };

  render() {
    const { data } = this.state;
    return (
      <div className="guide-wrapper">
        <div className="guide-title"></div>
        <div>
          <Tabs tabs={tabs} initialPage={2} animated={false} useOnPan={false}>
            <div
              style={{
                height: "2.5rem",
                backgroundColor: "#fff",
              }}
            >
              <div className="slogn-tab-neirong">{this.tabRender(lawData)}</div>
            </div>
            {/* <div
              style={{
                height: "2.5rem",
                backgroundColor: "#fff",
              }}
            >
              <div className="slogn-tab-neirong">{this.tabRender(policy)}</div>
            </div> */}
            <div
              style={{
                height: "2.5rem",
                backgroundColor: "#fff",
              }}
            >
              <div className="scroll-cont" ref={this.wrap}>
                <br />
                <p>
                  中国石化网上信访:
                  <br />
                  &nbsp;&nbsp;&nbsp;1．网上信访是指公民、法人或者其他组织通过中国石化网站、电子信箱、微信公众号等平台反映情况，提出建议、意见或者投诉请求，依法由有关机关、单位处理的活动。
                  <br />
                  <br />
                  &nbsp;&nbsp;&nbsp;2．根据《信访工作条例》第二十九、三十、三十一条规定，信访事项由有权处理机关、单位区分情况办理，其中属于《信访工作条例》第三十一条第六项规定的信访事项自受理之日起60日内办结；情况复杂的，延期30日办结。
                  <br />
                  <br />
                  &nbsp;&nbsp;&nbsp;3．依照《信访工作条例》的有关规定，中国石化信访部门不受理下列情况的事项：
                  <br />
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;（1）网上信访事项已经受理或者正在办理的，信访人在规定期限内（一般为60日）又提出同一信访事项的；
                  <br />
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;（2）已有处理（复查）意见且正在复查（复核）期限内，信访人再次提出相同信访事项的；
                  <br />
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;（3）对已有复核意见，信访人仍然以同一事实和理由提出投诉请求的；
                  <br />
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;另外，不受理匿名以及事实不清、责任主体不明的信访事项。
                  <br />
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;请您不要在法定期限内就同一信访事项重复网上信访。如已有处理（复查）意见，请及时向原办理机关、单位的上一级机关、单位申请复查（复核）。
                  <br />
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;感谢您的理解和支持！
                </p>
              </div>
            </div>
            <div
              style={{
                height: "2.5rem",
                backgroundColor: "#fff",
              }}
            >
              <div className="slogn-tab-neirong">{this.tabRender(answer)}</div>
            </div>
            <div
              style={{
                height: "2.5rem",
                backgroundColor: "#fff",
              }}
            >
              <div className="slogn-tab-neirong">
                {" "}
                {this.tabRender(focusing)}
              </div>
            </div>
          </Tabs>
          <WhiteSpace />
        </div>
        <div className="guide-process">
          <div className="process-title">网上信访流程</div>
          <div className="guide-cont">
            {processData.map((item, index) => {
              return (
                <div className="gutter-row" key={index}>
                  <div className="gutter-box">
                    <div
                      className="gutter-arrow"
                      style={{
                        background: `url(${item.bgUrl})`,
                        backgroundSize: "100% 100%",
                      }}
                    >
                      {item.name}
                    </div>
                    <div className="gutter-cent">{item.value}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}
